export enum WebSocketEventsEnum {
  // Connection lifecycle: emitted to the client once its token has been verified and it has
  // joined its rooms. The client keys "connection restored / authenticated" off this, since the
  // socket.io `connect` event fires before the gateway runs auth (the failure signal is
  // `unauthorized` + a server-initiated disconnect).
  authenticated = 'authenticated',
  // Rejection half of the handshake: emitted with a reason string when the token is missing or
  // invalid, followed by a server-initiated disconnect (which socket.io never auto-retries).
  unauthorized = 'unauthorized',

  customers = 'customers',
  InboundSmsEvent = 'InboundSmsEvent',
  parties = 'parties',
  reservations = 'reservations',
  newPublicCheckInEvent = 'newPublicCheckInEvent',
  displayOptions = 'displayOptions',
  reservationSettings = 'reservationSettings',
  settingsEvent = 'settingsEvent', // TODO: Avoid using this event
  VoiceSmsEvent = 'VoiceSmsEvent',
  TextSmsEvent = 'TextSmsEvent',
  exports = 'exports',
  webhooks = 'webhooks',
  events = 'events',
  togo = 'togo',

  // Notify users who assigned to location, all account admins
  locationCreated = 'locationCreated', // TODO: think about to replace strings with numbers
  // Notify users who assigned to location, all account admins
  locationUpdated = 'locationUpdated',
  // Notify users who assigned to location, all account admins
  locationDeleted = 'locationDeleted',

  // Will be used when user accepts invitation a new account
  accountCreated = 'accountCreated',
  // Notify users who assigned to account via account room
  accountUpdated = 'accountUpdated',
  // TODO: reserved, notify users who assigned to account
  accountDeleted = 'accountDeleted',

  news = 'news',

  // Notify an account about new user, e.g. signed up by invitation
  userCreated = 'userCreated',
  // Notify updated user and account
  userUpdated = 'userUpdated',
  userDeleted = 'userDeleted',
  // Notify only user via user room
  accountUserCreated = 'accountUserCreated',
  accountUserUpdated = 'accountUserUpdated',
  accountUserDeleted = 'accountUserDeleted',
  // Notify only user via user room
  locationUserCreated = 'locationUserCreated',
  locationUserUpdated = 'locationUserUpdated',
  locationUserDeleted = 'locationUserDeleted',

  // Notify only certain users
  tokenCreated = 'tokenCreated',
  tokenRevoked = 'tokenRevoked',

  /**
   * Location level events
   */
  // Notify location users via location room
  scheduleUpdated = 'scheduleUpdated',
  scheduleDeleted = 'scheduleDeleted',
  scheduleCreated = 'scheduleCreated',

  // Notify location users via location room
  resourceCreated = 'resourceCreated',
  resourceUpdated = 'resourceUpdated',
  resourceUpdatedBulk = 'resourceUpdatedBulk',
  resourceDeleted = 'resourceDeleted',

  // Notify location users via location room
  serviceCreated = 'serviceCreated',
  serviceUpdated = 'serviceUpdated',
  serviceUpdatedBulk = 'serviceUpdatedBulk',
  serviceDeleted = 'serviceDeleted',

  // Notify location users via location room
  blockedTimeCreated = 'blockedTimeCreated',
  blockedTimeUpdated = 'blockedTimeUpdated',
  blockedTimeDeleted = 'blockedTimeDeleted',

  // Invites
  invite = 'invite',

  // Price plans
  pricePlansUpdated = 'pricePlansUpdated',

  // Replies
  replyCreated = 'replyCreated',
  replyUpdated = 'replyUpdated',
  replyDeleted = 'replyDeleted',

  // Floor plans
  floorPlanCreated = 'floorPlanCreated',
  floorPlanUpdated = 'floorPlanUpdated',
  floorPlanDeleted = 'floorPlanDeleted',
  floorPlanItemCreated = 'floorPlanItemCreated',
  floorPlanItemUpdated = 'floorPlanItemUpdated',
  floorPlanItemDeleted = 'floorPlanItemDeleted',

  // Parties
  partyCreated = 'partyCreated',
  partyUpdated = 'partyUpdated',
  partyDeleted = 'partyDeleted', // Served or canceled
  // A stripe checkout hold became a confirmed booking (Notification Center only —
  // entity state still arrives via partyUpdated)
  partyPaymentConfirmed = 'partyPaymentConfirmed',

  // Notification Center
  messageRead = 'messageRead',
  notificationRead = 'notificationRead',
  allMessagesRead = 'allMessagesRead',
  allNotificationsRead = 'allNotificationsRead',

  locationBadgeUpdate = 'locationBadgeUpdate',

  // User session
  sessionRevoked = 'sessionRevoked',
}
